var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"enter-active-class":"animated bounceInRight","leave-active-class":"animated bounceOutRight"}},[_c('div',{staticClass:"protocol"},[_c('CommonHeader',[_vm._v("用户注册协议")]),_c('main',[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }